const state = {
  lang: 'zh',

  dynamicList: [],
  currentDynamic: {}
};

const mutations = {
  SET_DYNAMIC_DATA(state, value) {
    state.currentDynamic = value;
  },
  SET_DYNAMIC_LANG(state, val) {
    state.lang = val
  }
};

const actions = {

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/module/dynamic.js